import React from "react";
import { Provider as WagmiProvider } from "wagmi";
import { InjectedConnector } from "wagmi/connectors/injected";
import { WalletConnectConnector } from "wagmi/connectors/walletConnect";
import LocaleProvider from "providers/LocaleProvider";
import { providers } from "ethers";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { chains, infuraId, locales, theme } from "config";
import CurrencyProvider from "providers/CurrencyProvider";
import V2sProvider from "providers/V2sProvider";

const connectors = () => {
  return [
    new InjectedConnector({
      chains,
      options: { shimDisconnect: true },
    }),
    new WalletConnectConnector({
      chains,
      options: {
        infuraId,
        qrcode: true,
      },
    }),
  ];
};

const provider = ({ chainId }: { chainId?: number }) => {
  const network = providers.InfuraProvider.getNetwork(chainId!);
  if (network.ensAddress) {
    return new providers.InfuraProvider(network, infuraId);
  }
  return providers.getDefaultProvider();
};

const extendedTheme = extendTheme(theme);

const ComposedGlobalProviders: React.FC = ({ children }) => (
  <ChakraProvider theme={extendedTheme}>
    <WagmiProvider autoConnect provider={provider} connectors={connectors}>
      <LocaleProvider translations={locales.en}>
        <V2sProvider>
          <CurrencyProvider>{children}</CurrencyProvider>
        </V2sProvider>
      </LocaleProvider>
    </WagmiProvider>
  </ChakraProvider>
);

export default ComposedGlobalProviders;
